import { render } from "./propinarestaurante.vue?vue&type=template&id=60541762&scoped=true"
import script from "./propinarestaurante.vue?vue&type=script&lang=js"
export * from "./propinarestaurante.vue?vue&type=script&lang=js"

import "./propinarestaurante.vue?vue&type=style&index=0&id=60541762&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60541762"]])

export default __exports__